import ApiService from '@shared/services/api.service';

const AdminService = {
  fetch24HoursAlertsGenerated: async () => ApiService.get('admin/analytics/hourly_alert_count_last_24_hours'),
  fetch24HoursAlertsGeneratedByGenAi: async () => ApiService.get('admin/analytics/hourly_genai_alert_count_last_24_hours'),
  fetchDailyAlertsGenerated: async (numberOfDays) => ApiService.get(`admin/analytics/daily_alert_count_last_days/${numberOfDays}`),
  fetchDailyAlertsGeneratedByGenAi: async (numberOfDays) => ApiService.get(`admin/analytics/daily_genai_alert_count_last_days/${numberOfDays}`),
  fetchAlertsByCustomer: async (window) => ApiService.get(`admin/analytics/alerts_by_customer/${window}`),
  fetchOpsReport: async (report) => ApiService.get(`admin/analytics/ops_report/${report}`),
  fetchAiTriageModels: async () => ApiService.get('ai-triage/models'),
  fetchCustomerAiTriageModelConfig: async (customerId) => ApiService.get(`ai-triage/customers/${customerId}/model-config`),
  updateCustomerAiTriageModelConfig: async (customerId, body) => ApiService.put(`ai-triage/customers/${customerId}/model-config`, body),
};

export default AdminService;
